import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import {
  withStyles
} from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Drawer from 'material-ui/Drawer'
import List, {
  ListItem,
  ListItemIcon,
  ListItemText
} from 'material-ui/List'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import * as SiteConfig from '../../config/Config'

const styles = theme => ({
  drawerHeader: {
    position: 'relative',
    height: '100%',
    width: 250,
    // width: drawerWidth,
    paddingLeft: '20px'
  },
  menuButton: {
    color: theme.palette.primary.contrastText,
  },
  link: {
    textDecoration: "none",
  },
})

class MenuDrawer extends Component {
    state = {
      open: {
        left: false
      },
    }

    toggleDrawer = (side, open) => {
      const drawerState = {};
      drawerState[side] = open;
      this.setState({ open: drawerState });
    };

    handleOpen = () => {
      this.toggleDrawer('left', true);
    };

    handleClose = () => {
      this.toggleDrawer('left', false);
    };

    render(){
      const { classes } = this.props

      // let drawerHeaderSection = config.site.type === 'title'
      //   ? config.site.title
      //   : <img src={config.site.logo} alt={config.site.altText} />

      let sideList = (
        <div>
          <div className={classes.drawerHeader}>
            {/* {drawerHeaderSection} */}
          </div>
          <Divider />
          <List>

            <Link to="/" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <FontAwesomeIcon icon={SiteConfig.pages.home.headerIcon} />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItem>
            </Link>

            <Link to="/about" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <FontAwesomeIcon icon={SiteConfig.pages.about.headerIcon} />
                </ListItemIcon>
                <ListItemText primary="About" />
              </ListItem>
            </Link>

            {/* <Link to="/portfolio" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <FontAwesomeIcon icon={SiteConfig.pages.portfolio.headerIcon} />
                </ListItemIcon>
                <ListItemText primary="Portfolio" />
              </ListItem>
            </Link> */}

            <Link to="/contact" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <FontAwesomeIcon icon={SiteConfig.pages.contact.headerIcon} />
                </ListItemIcon>
                <ListItemText primary="Contact" />
              </ListItem>
            </Link>

            {SiteConfig.hasLogin &&
              <Divider />
            }

            {SiteConfig.login &&
              <a href={SiteConfig.login.url} alt="" style={{ paddingLeft: '15px' }} className={classes.link}>
                <ListItem button>
                  <ListItemIcon>
                    <FontAwesomeIcon icon={SiteConfig.login.icon} />
                  </ListItemIcon>
                  <ListItemText primary="Login" />
                </ListItem>
              </a>
            }

          </List>
        </div>
      );

      let menuIcon = this.state.open.left
        ? <FontAwesomeIcon icon={SiteConfig.menu.openIcon} />
        : <FontAwesomeIcon icon={SiteConfig.menu.closeIcon} />

      return (
        <div>
          
          <IconButton
            onClick={this.handleOpen}
            className={classes.menuButton}
            aria-label="Menu"
          >

            {menuIcon}

          </IconButton>

          <Drawer
            open={this.state.open.left}
            onClick={this.handleClose}
          >
            {sideList}
          </Drawer>

        </div>
      )
    }
  }

  MenuDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
  };

  export default withStyles(styles)(MenuDrawer);



// WEBPACK FOOTER //
// ./src/components/Header/menu-drawer.js